// extracted by mini-css-extract-plugin
module.exports = {"header":"visual-content-section_header__tIdoc","entryTitle":"visual-content-section_entryTitle__Na2_9","content":"visual-content-section_content__zxSeP"};